import { Grid } from '@mui/material';
import React from "react";
import { useTranslation } from "react-i18next";
import InicioCard from "../../../components/InicioCard";
import AAFFIcon from "../../../images/aaff.png"
import ConsultoresIcon from "../../../images/consultores.png"
import TecnicosIcon from "../../../images/tecnicos.png"
import ProveedoresIcon from "../../../images/proveedores.png"

function Inicio() {
  const { t } = useTranslation('common');

  return (<>
    <div style={{
      textAlign: 'center',
      fontSize: 28,
      color: "#303248",
      fontWeight: 'bold',
      paddingTop: 90
    }}>{t('home.welcome')}</div>
    <div style={{
      textAlign: 'center',
      fontSize: 22,
      color: "#303248",
      marginTop: 10,
      marginBottom: 70
    }}>{t('home.whatToDo')}</div>
    <Grid container direction="row" justifyContent="center" alignItems="center" spacing={5}>
      <Grid item><InicioCard icono={AAFFIcon} texto={t('home.manageAaff')} ruta="/aaff" /></Grid>
      <Grid item><InicioCard icono={ConsultoresIcon} texto={t('home.manageConsultants')} ruta="/consultores" /></Grid>
      <Grid item><InicioCard icono={ProveedoresIcon} texto={t('home.manageSuppliers')} ruta="/proveedores" /></Grid>
      <Grid item><InicioCard icono={TecnicosIcon} texto={t('home.manageTechnicians')} ruta="/tecnicos" /></Grid>
      <Grid item><InicioCard icono={TecnicosIcon} texto={t('home.manageCommercials')} ruta="/comerciales" /></Grid>
    </Grid>

  </>);
}

export default Inicio;
